"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.coolUpload = void 0;

var _httpRequest = _interopRequireDefault(require("../httpRequest"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * @file 上传图片函数
 * @eric
 * @date 2020/09/23
 */
var NODE_SERVER = 'https://nt.igetcool.com/api/upload';

// export const coolGetCDNImageColort = (imgUrl) => {
//   return httpRequest.get('https://coolcdn.igetcool.com/p/2020/9/61a0b0f594af566e1bc3a73e4d27e394.jpg?_220x220.jpg')
// }
var coolUpload = function coolUpload() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var file = options.file,
      _options$proxyUrl = options.proxyUrl,
      proxyUrl = _options$proxyUrl === void 0 ? '/imagecompress' : _options$proxyUrl;
  return new Promise(function (resolve, reject) {
    if (!file) {
      reject('error!!!there is no image!!!');
    }

    var formData = new FormData();
    formData.append('file', file);

    try {
      _httpRequest["default"].post(proxyUrl, formData).then(function (res) {
        if (res) {
          resolve(res);
        }
      });
    } catch (error) {
      reject(error);
    }
  });
};

exports.coolUpload = coolUpload;